/***
 * Configuration for Contracts Routes
 *
 * Contract Routes
 * Intervention Plan Routes
 ***/

/* ----- Views ----- */

// Contract
import Contracts from "@/pages/Contracts/Contracts";
import ContractDetails from "@/pages/Contracts/ContractDetails";
import ContractEdit from "@/pages/Contracts/ContractEdit";

// Intervention Plan
import InterventionPlanAdd from "@/pages/Contracts/InterventionPlan/InterventionPlanAdd";
import InterventionPlanEdit from "@/pages/Contracts/InterventionPlan/InterventionPlanEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

// Parents List
const parentsList = {
    contractsIndex: { label: 'Liste des contrats', name: 'Contracts' },
    contractDetails: {
        label: 'Détails d\'un contrat',
        name: 'Contract Details',
        params: { name: 'contractId', model: 'Contract', column: 'number' },
    },
}

const contractRoutes = [
    {
        path: 'contracts',
        name: 'Contracts',
        component: Contracts,
        meta: {
            route: {
                label: 'Liste des contrats'
            }
        },
    },
    {
        path: 'contracts/:contractId',
        name: 'Contract Details',
        component: ContractDetails,
        meta: {
            route: {
                label: 'Détails d\'un contrat',
                params: { name: 'contractId', model: 'Contract', column: 'number' },
            },
            parents: generateParentsList(parentsList, ['contractsIndex']),
        },
    },
    {
        path: 'contracts/:contractId/edit',
        name: 'Contract Edit',
        component: ContractEdit,
        meta: {
            route: {
                label: 'Modification du contrat'
            },
            parents: generateParentsList(parentsList, ['contractsIndex', 'contractDetails']),
        },
    },
]

const interventionPlanRoutes = [
    {
        path: 'contracts/:contractId/intervention_plan/create',
        name: 'Intervention Plan Add',
        component: InterventionPlanAdd,
        meta: {
            route: {
                label: 'Ajout d\'un plan d\'intervention'
            },
            parents: generateParentsList(parentsList, ['contractsIndex', 'contractDetails']),
        },
    },
    {
        path: 'contracts/:contractId/intervention_plan/:planningInterventionId/edit',
        name: 'Intervention Plan Edit',
        component: InterventionPlanEdit,
        meta: {
            route: {
                label: 'Modification du plan d\'intervention'
            },
            parents: generateParentsList(parentsList, ['contractsIndex', 'contractDetails']),
        },
    },
]

const routes = [...contractRoutes, ...interventionPlanRoutes]
export default routes